<template>
  <div :class="onClick || url ? 'text-click text-center' : 'text-dash text-center'" :style="bgStyle" @click="clicked">

      <el-row align="center">
        <el-col  v-if="isAbove" :span="24" align="center">
          <span :style="valueStyle">{{thisValue}}</span>
        </el-col>

        <el-col :span="24" align="center">
            <span v-if="!isAbove" :style="valueStyle">{{thisValue}}</span>
            &nbsp;<i v-if="icon" :style="iconStyle" :class="icon"></i>
        </el-col>

      </el-row>

      <el-row :style="captionStyle">
        <el-col :span="24" align="center">
          {{noPlural ? caption : plural(caption, thisValue)}}
        </el-col>
      </el-row>

  </div>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  name: 'dash-text',

  mixins: [NumberMixins],

  props: {
    value: {
//      type: [String, Number],
      requried: true
    },

    color: {
      type: String,
      default: 'slateblue'
    },

    size: {
      type: String,
      default: '1.74rem'
    },

    caption: {
      type: String
    },

    noPlural: {
      type: Boolean,
      default: false
    },

    captionColor: {
      type: String,
      default: 'slategrey'
    },

    captionSize: {
      type: String,
      default: '1.2rem'
    },

    icon: {
      type: String,
      default: null
    },

    iconColor: {
      type: String,
      default: null
    },

    align: {
      type: String,
      default: 'top'
    },

    background: {
      type: String
    },

    radius: {
      type: Number,
      default: 20
    },

    unit: {
      type: String,
      default: 'rem'
    },

    currency: {
      type: Boolean,
      default: false
    },

    decimals: {
      type: Number,
      default: 0
    },

    onClick: {
      type: Function,
      default: null
    },

    url: {
      type: String,
      default: null
    }

  },



  methods: {

    clicked () {
      if (this.onClick) {
        this.onClick()
      }

      if (this.url) {
        this.$router.push(this.url)
      }
    },

    formatValue (value) {

      return (typeof value === 'number'
        ? (this.currency
          ? this.formatMoney(value, this.decimals)
          : this.formatNumber(value, this.decimals))
        : value)

    }
  },


  computed: {
    isAbove: function () {
      return this.align.toLowerCase().trim() === 'top'
    },

    isBelow: function () {
      return this.align.toLowerCase().trim() === 'below'
    },

    isCenter: function () {
      return this.align.toLowerCase().trim() === 'center'
    }
  },


  watch: {
    value: function (changed) {
      this.thisValue = this.formatValue(changed)
    }
  },


  data () {
    return {
      thisValue: this.formatValue(this.value),
      valueStyle: 'font-size: ' + this.size + '; color: ' + this.color,
      iconStyle: 'font-size: ' + this.size + '; color: ' + (this.iconColor ? this.iconColor : this.color),
      captionStyle: 'font-size: ' + this.captionSize + '; color: ' + this.captionColor,
      bgStyle: this.background ? 'background-color: ' + this.background : '; border-radius: ' + this.radius + this.unit + ';'
    }
  }
}

</script>

<style scoped>
.text-dash {cursor: default; padding: 1.174em;}
.text-click {cursor: pointer;}
.text-click:hover {
  border: 0.285px solid #E9E9EB;
  padding-left: 0.174px;
  padding-right: 0.174px;
  border-radius: 0.174px;
  animation-duration: 0.25s;
  box-shadow: 0 0.528px 0.528px rgba(0,0,0,0.25), 0 0.528px 0.528px rgba(0,0,0,0.22);
}
</style>
